import { Container } from "react-bootstrap"

const CrossPlatformCaseStudy = () => {
    return (
        <section className="case-study-content-block py-5">
            <Container>
                <div>
                    <h2 className="text-primary ft-wt-700 mb-4">eCommerce Web and Mobile App</h2>

                    <p>Mobile commerce is growing exponentially these days. If a company wants to build a successful enterprise and focus on attracting customers, increasing sales and building customer loyalty, the importance of having mobile e-Commerce solutions should be obvious. This mobile application along with web application gives company’s business a competitive advantage.</p>

                    <p>We developed a complete eCommerce mobile app solution including both Android and iOS platforms with Single Code base using React, React Native, NodeJs, MongoDB, PostgreSQL, AWS Cloud and Machine Learning. What users can do with this mobile application. We have used branch.io for deep linking. We integrated Twilio SMS API gateway.</p>

                    <ul>
                        <li>Easy login &amp; registration and create their personal profile.</li>
                        <li>User-friendly product filtering and sorting.</li>
                        <li>Detailed product descriptions and Product gallery.</li>
                        <li>Presenting products with Augmented Reality.</li>
                        <li>Item availability reminder and Wishlist.</li>
                        <li>Create a digitized locker to keep cart items safe and secure.</li>
                        <li>Product recommendations based on Sentiment Analysis using Machine Learning.</li>
                        <li>Use the in-built secure e-Wallet for transactions and secure payment gateway options.</li>
                        <li>Interactive interface that could support all the above features without compromising Application performance.</li>
                    </ul>
                </div>
            </Container>

        </section>
    )
}

export default CrossPlatformCaseStudy